React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
View = require 'app/scripts/views/internal/view'
{ renderComponent } = require 'app/src/components/ComponentWrapper'

module.exports = class DomainFreeTeamLimitRestrictedBanner extends View
  initialize: ->
    @loadBannerPromise ?= `import(/* webpackChunkName:"free-team-limit-banners"*/'app/src/components/FreeTeamLimitBanners')`
      .then((module) =>
        @RestrictedBanner = module.RestrictedBanner
        @render()
      )

  render: ->
    if (!@RestrictedBanner)
      return @

    banner = React.createElement(@RestrictedBanner, {
      memberId: @model.get('id'),
      onDismiss: =>
        @remove()
    })
    renderComponent(banner, @el)
    @

  remove: ->
    ReactDOM.unmountComponentAtNode(@el)
    super
